import { render, staticRenderFns } from "./AmountCell.vue?vue&type=template&id=c956b220&"
import script from "./AmountCell.vue?vue&type=script&lang=js&"
export * from "./AmountCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports